import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-info-box',
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.scss'],
    standalone: false
})
export class InfoBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
